import React from "react";

import { Drawer as MuiDrawer, DrawerProps as MuiDrawerProps } from "@mui/material";
import { SimpleHeadMui } from "components/Simple-head/SimpleHeadMui";

interface Props extends MuiDrawerProps {
  title: string;
}

export const Drawer: React.FC<Props> = ({ children, title, ...props }) => {
  return (
    <MuiDrawer
      {...props}
      sx={{
        ".MuiPaper-root": {
          borderRadius: "0 25px 25px 0",
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          overflow: "hidden",
          width: "470px",
          height: "100%"
        }
      }}
    >
      <SimpleHeadMui onIconClick={() => props.onClose?.({}, "backdropClick")}>{title}</SimpleHeadMui>
      {children}
    </MuiDrawer>
  );
};
